import { useCallback } from 'react';
import { toast } from 'react-toastify';
import CustomToast from '../components/CustomToast';

const useCustomToast = () => {
  const showToast = useCallback((message, type = 'info', options = {}) => {
    toast(<CustomToast message={message} type={type} />, {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      ...options
    });
  }, []);

  const successToast = useCallback((message, options = {}) => {
    toast(<CustomToast message={message} type="success" />, {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      containerId: 'main-toast-container',
      ...options
    });
  }, []);

  const errorToast = useCallback((message, options = {}) => {
    toast(<CustomToast message={message} type="error" />, {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      containerId: 'main-toast-container',
      ...options
    });
  }, []);

  const warningToast = useCallback((message, options = {}) => {
    toast(<CustomToast message={message} type="warning" />, {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      ...options
    });
  }, []);

  const infoToast = useCallback((message, options = {}) => {
    toast(<CustomToast message={message} type="info" />, {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      ...options
    });
  }, []);

  return {
    showToast,
    successToast,
    errorToast,
    warningToast,
    infoToast
  };
};

export default useCustomToast; 